// The basics
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';

// Action creators and helpers
import { establishCurrentUser } from '../modules/auth';
import { sendTokenToHost, goToPageAndHeader, computePurchasePage, computeContinueTrialHeader, saveError,goToPage } from '../state/lic_state';
import Routes from './routes';

import { isServer, serverclientPrefix } from '../store';
import Localizer from '../format/localizer';
import {LogCategory,log } from '../api/logger';
var HeaderType = require('../state/headerType');

var Page = require('../constants/page');

class App extends Component {
    componentWillMount() {
        if ( !isServer) {
            // for now, just have everything in english
            Localizer.init(this.props.lic_state.language);

            var state = this.props.lic_state;
            if ( state.token != "")
                this.props.sendTokenToHost(state);

            var goToPageAndHeader = this.props.goToPageAndHeader;
            // this part is duplicated in loader; we can't avoid it, because of how React handles dispatch()
            window.goToPage = page => {
                log(LogCategory.info,"window go to page" + page);
                switch (page) {
                    case "continueTrial":
                        let header = computeContinueTrialHeader(state);
                        goToPageAndHeader( {
                            header: header,
                            license: header == HeaderType.Hm3 ? state.licenseHm3 : state.licenseOmaha,
                            page: Page.ContinueTrial
                        } );
                        break;

                    case "hm3Purchase":
                        goToPageAndHeader( {
                            header: HeaderType.Hm3,
                            license: state.licenseHm3,
                            page: computePurchasePage( state.licenseHm3, state.fromStartup),
                        } );
                        break;

                    case "om3Purchase":
                        goToPageAndHeader( {
                            header: HeaderType.Omaha,
                            license: state.licenseOmaha,
                            page: computePurchasePage( state.licenseOmaha, state.fromStartup),
                        } );
                        break;
                    case "maintenanceOptionsHm3Page":
                        return goToPageAndHeader( {
                            header: HeaderType.Hm3,
                            license: state.licenseHm3,
                            page: Page.MaintenanceOptions,
                        } );
                    case "maintenanceOptionsOmahaPage":
                        return goToPageAndHeader( {
                            header: HeaderType.Omaha,
                            license: state.licenseOmaha,
                            page: Page.MaintenanceOptions,
                        } );
                }
            };

            var goToPage = this.props.goToPage;
            var saveError = this.props.saveError;
            window.onNetellerFinish = success => {
                if ( success)
                    goToPage(Page.PaymentReview);
                else {
                    saveError({page: Page.Netteller, success: false, errors: { general: [{ message: "NETELLER transaction canceled. Please login again or choose another payment method."}] } });
                    goToPage(Page.Netteller);
                }

            };
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    render() {

        return (
          <div>
              <Routes />
          </div>
        );
    }
}

const mapStateToProps = state => ({
    lic_state: state.lic_state
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({ sendTokenToHost, goToPageAndHeader, computePurchasePage, computeContinueTrialHeader, saveError,goToPage }, dispatch);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(App)
);



// WEBPACK FOOTER //
// ./src/app/app.js